import { fn } from '@common/utils';
import resolveToError = fn.resolveToError;
import { KWFFormSession } from '../KWFEdit';
import { SessionEvents } from '@common/rwf/rwfedit.common';
import { CompatibilityService } from '../services/compatibilityservice';
import { DialogService } from '../services/dialogservice';
import { NavClientService } from '@common/navdata';
import { RWF3BaseService } from './rwf3baseservice';

/** MassOpen Queue : allows "pre- Loading" next Instance to load for better Performance */
export class KFWFormSessionQueue {
    /** Current Active Queue Instance */
    public static Current?: KFWFormSessionQueue;

    /** Open Next Mass item if any */
    public static OpenNextMassItem() {
        var curr = KFWFormSessionQueue.Current;
        return curr && curr.openNextMassItem();
    }

    /** CleanUp Current Queue, Closing opt. Prefetched Session */
    public static Cleanup() {
        var curr = KFWFormSessionQueue.Current;
        delete KFWFormSessionQueue.Current;
        return curr && curr.cleanup();
    }

    public readonly TotalCount: number;

    public get CurrentIdx() { return this.TotalCount - this.ids.length; }

    constructor(private injector: ng.auto.IInjectorService, private NavClient: NavClientService,
        private $c: CompatibilityService, private readonly ids: (string | PromiseLike<KWFFormSession>)[]) {
            this.TotalCount = ids.length;
        }

    private PopSession(): PromiseLike<KWFFormSession> {
        let injector = this.injector,
            $c = this.$c,
            DialogService = injector.get<DialogService>("DialogService"),
            ids = this.ids,
            /** Create Session by Instance id */
            createSession = (nextId: string) => {
                return RWF3BaseService.Create($c, nextId, this.NavClient.NavUrl).then((adapter) => {
                    return adapter.AttachSession(new KWFFormSession($c, adapter));
                });
            },
            /** Pre Load Item */
            peek = (idx = 0) => {
                var nextAfter = ids[idx];

                // Prepare Next session ....
                if (nextAfter && !fn.isPromise(nextAfter)) {
                    var check = ids[idx] = createSession(nextAfter);
                    check.then(undefined, err => peek(idx + 1)); // try preload next on error
                }
            }, onError = (err) => {
                return DialogService.ShowError("Nächster Beleg kann nicht geöffnet werden:\n" + resolveToError(err), "Stapelöffnen").then(() => {
                    return this.PopSession();
                });
            };

        var result = this.$c.when().then(() => {
            if (this.ids.length == 0)
                throw new Error('Keine weiteren Formulare zum Öffnen vorhanden!');

            var nextId = ids.splice(0, 1)[0];

            if (fn.isPromise(nextId)) {
                return nextId.then(fn.identity, onError);
            } else {
                return createSession(nextId);
            }
        }).then(fn.identity, err => {
            if (ids.length > 0) {
                return onError(err);
            }
            throw err;
        });

        result.then(() => peek(), () => peek());
        return result;
    }

    /** Open Next Mass Item */
    public openNextMassItem(): PromiseLike<boolean> {
        let route = "/kwfEditForm/",
            injector = this.injector,
            $location = injector.get<ng.ILocationService>("$location"),
            DialogService = injector.get<DialogService>("DialogService"),
            $q = this.$c;

        if (this.ids.length == 0)
            return $q.when(false);

        return this.PopSession().then(session => {
            var urlToOpen = route + session.ID;
            var search = $location.search();
            search["mass"] = session.ID;
            if (!search["source"])
                search["source"] = $location.url();
            // Not nice : Handling Error in Resolve with taking next item in mass scenario must should be unified
            KWFFormSession.PendingOpen = session;
            $location.path(urlToOpen).search(search);
            return true;
        }, err => {
            return DialogService.ShowError("Nächster Beleg kann nicht geöffnet werden:\n" + resolveToError(err), "Stapelöffnen").then(() => {
                return this.openNextMassItem();
            });
        });
    }

    private cleanup() {
        var ids = this.ids.splice(0, this.ids.length);
        return this.$c.when().then(() => {
            return this.$c.all(ids.filter(item => fn.isPromise(item)).map(item => {
                if (fn.isPromise(item)) {

                    return item.then(ss => {
                        ss.bindWithDefer(e => {
                            e.preventDefault();
                        }, SessionEvents.destroy);
                        ss.Close(false);
                    });
                }
            }));
        }).then(fn.noop);
    }
}
